import { isAfter } from 'date-fns'

import { BillingStateSchema } from 'src/lib/zod-schemas/organization-subscription.schema'
import logger from 'src/utils/logger'

/**
 * @param {Array<import('zod').infer<typeof BillingStateSchema>>} billingStates Array of billing state objects
 * @param {string} module_name The module to check for (e.g., 'plan', 'practice', etc.)
 * @returns {boolean}
 */
export default function moduleValid(billingStates, module_name) {
    try {
        const now = new Date()
        return billingStates.some((billingState) => {
            const parsed = BillingStateSchema.parse(billingState)
            const mod = parsed.subscription_modules.find(
                (m) => m.module_name === module_name
            )
            return mod && isAfter(mod.end_date, now)
        })
    } catch (error) {
        logger.error('parsing error', error)
        return false
    }
}
